@if (loading) {
  <mat-progress-bar mode="buffer" class="dialog-progress"></mat-progress-bar>
}

<div class="standard-dialog">
  <!-- CHOOSE CONTENT TYPE -->
  @if (data.type === 'choose-content-type') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Global.CreateNewContent' | translate }}</h2>
        <p class="subtitle">{{ 'Global.SelectContentTypeDesc' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.ContentType' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-select-field w-100" subscriptSizing="dynamic">
          <mat-select [(ngModel)]="selectedContentType" name="contentType">
            <mat-option value="course">{{ 'Global.Knowledge' | translate }}</mat-option>
            <mat-option value="blog">{{ 'Global.Article' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      @if (selectedContentType) {
        <div class="w-100">
          <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
          <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
            <input
              matInput
              [disabled]="loading"
              [(ngModel)]="currentName"
              autocomplete="off"
              [placeholder]="(selectedContentType === 'course' ? 'Content.EnterTitle' : 'Content.EnterArticleTitle') | translate"
            />
          </mat-form-field>
        </div>
        <div class="w-100">
          <mat-label class="form-label">{{ 'Global.Description' | translate }}</mat-label>
          <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
            <textarea matInput [disabled]="loading" [(ngModel)]="currentDescription" rows="4" [placeholder]="'Content.EnterDescriptionExample' | translate"></textarea>
          </mat-form-field>
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        @if (selectedContentType) {
          <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="onSubmit()">
            {{ 'Global.Create' | translate }}
          </button>
        }
      </div>
    </mat-dialog-actions>
  }



  <!-- COURSE -->
  @if (data.type === 'course') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Courses.Overview.CreateCourse' | translate }}</h2>
        <p class="subtitle">{{ 'Courses.Overview.CreateCourseDesc' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <input matInput type="text" [disabled]="loading" [(ngModel)]="courseName" autocomplete="off" [placeholder]="'Content.EnterTitle' | translate" />
        </mat-form-field>
      </div>
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Description' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <textarea matInput [disabled]="loading" [(ngModel)]="newCourseDescription" rows="4" [placeholder]="'Content.EnterDescriptionExample' | translate"></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="onSubmit()">
          {{ 'Global.Create' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }

  <!-- SET TITLE -->
  @if (data.type === 'set-title') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Courses.Overview.EditCourseName' | translate }}</h2>
        <p class="subtitle">{{ 'Global.UpdateDetails' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <input matInput [disabled]="loading" (keyup.enter)="editCourse('title')" [(ngModel)]="newCourseName" [placeholder]="'Content.EnterTitle' | translate" />
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="editCourse('title')">
          {{ 'Global.Save' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }

  <!-- SET DESCRIPTION -->
  @if (data.type === 'set-description') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Courses.Overview.EditCourseDesc' | translate }}</h2>
        <p class="subtitle">{{ 'Global.UpdateDetails' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Description' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <textarea
            matInput
            [disabled]="loading"
            (keyup.enter)="editCourse('description')"
            [(ngModel)]="newCourseDescription"
            rows="5"
            [placeholder]="'Content.EnterDescriptionExample' | translate"
          ></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="editCourse('description')">
          {{ 'Global.Save' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }

  <!-- EDIT NOTE -->
  @if (data.type === 'edit-note') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Notes.Edit' | translate }}</h2>
        <p class="subtitle">{{ 'Notes.EditDesc' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Notes.Name' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <input matInput [disabled]="loading" [(ngModel)]="newNoteName" [placeholder]="'Notes.EnterNoteTitle' | translate" />
        </mat-form-field>
      </div>
      <div class="w-100">
        <mat-label class="form-label">{{ 'Notes.Description' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <textarea matInput [disabled]="loading" [(ngModel)]="newNoteDescription" rows="4" [placeholder]="'Global.EnterDescription' | translate"></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="editNote()">
          {{ 'Global.Save' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }



  <!-- CREATE PATH -->
  @if (data.type === 'create-path') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Path.AddPath' | translate }}</h2>
        <p class="subtitle">{{ 'Path.AddPathDesc' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <input matInput [disabled]="loading" [(ngModel)]="pathName" [placeholder]="'Path.EnterPathTitle' | translate" />
        </mat-form-field>
      </div>
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Description' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <textarea matInput [disabled]="loading" [(ngModel)]="pathDescription" rows="4" [placeholder]="'Global.EnterDescription' | translate"></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="createPath()">
          {{ 'Global.Create' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }

  <!-- EDIT PATH -->
  @if (data.type === 'edit-path') {
    <div class="header" mat-dialog-title>
      <div class="title-section">
        <h2>{{ 'Path.EditPath' | translate }}</h2>
        <p class="subtitle">{{ 'Path.EditPathDesc' | translate }}</p>
      </div>
      <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="form-content">
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Name' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <input matInput [disabled]="loading" [(ngModel)]="pathName" [placeholder]="'Path.EnterPathTitle' | translate" />
        </mat-form-field>
      </div>
      <div class="w-100">
        <mat-label class="form-label">{{ 'Global.Description' | translate }}</mat-label>
        <mat-form-field appearance="fill" class="soft-input w-100" subscriptSizing="dynamic">
          <textarea matInput [disabled]="loading" [(ngModel)]="pathDescription" rows="4" [placeholder]="'Global.EnterDescription' | translate"></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="footer">
      <div class="left-actions"></div>
      <div class="right-actions">
        <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" [disabled]="buttonLock" (click)="editPath()">
          {{ 'Global.Save' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
</div>
